var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { mapValues, reverseMap } from "healthex-common/utils";
import { findMatchingNamedRouteParent } from "./RoutingUIManager";
export class NavigationHelper {
    constructor(routingUIManager, navigationItemToRoutes) {
        this.routingUIManager = routingUIManager;
        this.navigationItemToRoutes = navigationItemToRoutes;
        this.routeNamesToNavigationItem = this.reverseStringToRouteMap(this.navigationItemToRoutes);
    }
    navigationItemToRoute(navigationItem) {
        return this.navigationItemToRoutes[navigationItem];
    }
    navigateTo(navigationItem, routeParams = {}) {
        this.routingUIManager.navigateTo(this.navigationItemToRoute(navigationItem), routeParams);
    }
    redirectTo(navigationItem, routeParams = {}) {
        this.routingUIManager.redirectTo(this.navigationItemToRoute(navigationItem), routeParams);
    }
    registerRedirect(navigationItem, handler) {
        this.routingUIManager.registerRedirect(this.navigationItemToRoute(navigationItem), (routeParams) => {
            const result = handler(routeParams);
            if (result === null) {
                return null;
            }
            else if (typeof result === "string") {
                return this.navigationItemToRoute(result);
            }
            else {
                return {
                    route: this.navigationItemToRoute(result.navigationItem),
                    routeParams: result.routeParams,
                };
            }
        });
    }
    get currentNavigationItem() {
        var _a;
        if (!this.routingUIManager.currentRoute)
            return null;
        const navigationItems = Object.values(this.navigationItemToRoutes);
        const currentRoute = findMatchingNamedRouteParent(this.routingUIManager.currentRoute, navigationItems);
        if (!currentRoute)
            return null;
        return (_a = this.routeNamesToNavigationItem[currentRoute.routeName]) !== null && _a !== void 0 ? _a : null;
    }
    reverseStringToRouteMap(map) {
        return reverseMap(mapValues(map, (route) => route.routeName));
    }
}
__decorate([
    computed
], NavigationHelper.prototype, "currentNavigationItem", null);
